import ajax, { append } from './index'

//现金券订单列表
export function cashcouponorderList(url) {
  return ajax.get('/admin/order/cash_coupon_order/list?' + url)
}

//商品订单列表
export function orderproductorderList(url) {
  return ajax.get('/admin/order/product_order/list?' + url)
}

//商品订单详情
export function orderProductDetailData(url) {
  return ajax.get('/admin/order/cash_coupon_order/detail?order_no=' + url)
}

//现金券列表
export function activityCashCouponList(url) {
  return ajax.get('/admin/activity/cash_coupon/list?' + url)
}

//现金券详情
export function activityCashCouponInfo(url) {
  return ajax.get('/admin/activity/cash_coupon_info?' + url)
}
//现金券删除
export function activityDeleteCashCoupon(data) {
  return ajax.post('/admin/activity/delete_cash_coupon', data)
}
//现金券购买记录
export function activityCouponBuyRecord(url) {
  return ajax.get('/admin/activity/coupon_buy_record?' + url)
}

//现金券下架
export function activityDownCashCoupon(data) {
  return ajax.post('/admin/activity/downCashCoupon', data)
}
//获取线上商户
export const getOnlinBusiness = data => {
  return ajax.get(`/admin/shop/search${append(data)}`)
}

//获取用户列表
export const getNormalUser = data => {
  return ajax.get(`/admin/user/search${append(data)}`)
}
//获取用户列表-新
export const getNormalUserNew = data => {
  return ajax.get(`admin/user/search${append(data)}`)
}
//获取用户详情
export const getUserDetail = data => {
  return ajax.get(`/admin/user/get${append(data)}`, {})
}

//获取红包记录
export const getUserHbHistory = data => {
  return ajax.get(`/admin/user/red_picket/search${append(data)}`, {})
}
//充值红包
export const rechargeHb = data => {
  return ajax.post('admin/user/add_red_picket', data)
}

//获取用户红包列表
export function cardTljList(url) {
  return ajax.get('admin/card/tlj/search?' + url)
}

//红包领取详情
export function redPacketGetDetail(id) {
  return ajax.get('admin/red_racket/' + id + '/red_racket_receive/list')
}

//用户列表-解除绑定手机号
export const removeMobile = data => {
  return ajax.post(`admin/user/unbundling`, data)
}

//用户列表-绑卡解封
export const removeCard = data => {
  return ajax.post(`admin/user/set_unseal`, data)
}

//用户列表-冻结
export const frozen = data => {
  return ajax.post(`soso/api/user/black/add`, data)
}

//用户列表-解冻
export const thaw = data => {
  return ajax.post(`soso/api/user/black/del`, data)
}

export const confirmDeduct = data => {
  return ajax.post(`admin/user/withholding_money`, data)
}

export const sourceFrom = () => {
  return ajax.get(`admin/card/tlj/source_from`)
}

export const getFreeManage = url => {
  return ajax.get('admin/user/shop_info?' + url)
}

export const getFreeGoods = url => {
  return ajax.get('admin/user/goods_info?' + url)
}

export const freeSetStatus = data => {
  return ajax.post(`admin/user/set_status`, data)
}
export const freeGetSku = data => {
  return ajax.post(`admin/user/get_sku`, data)
}
export const freeInspect = data => {
  return ajax.post(`admin/user/inspect`, data)
}
export const freeAddGoods = data => {
  return ajax.post(`admin/user/add_goods`, data)
}
export const freeEditSku = data => {
  return ajax.post(`admin/user/edit_sku`, data)
}